<template>
	<div class="message-box">
		<h2 class="body-text-2 jablue">{{ $t('anotherStudentConcurrent1') }}</h2>
		<h2 class="body-text-2 jablue bigger">
			{{ this.$route.query.email.split('@')[0] }}
		</h2>
		<h2 class="body-text-2 jablue">
			@{{ this.$route.query.email.split('@')[1] }}
		</h2>
		<h2 class="body-text-2 jablue">{{ $t('anotherStudentConcurrent2') }}</h2>
		<div class="buttons-con">
			<div class="action-link-wrap">
				<router-link to="/force" class="link-button">log in anyway</router-link>
				<a
					class="link-button link-back-button"
					tabindex="0"
					@click="logout()"
					>{{ $t('logOut') }}</a
				>
			</div>
		</div>
		<h3 class="body-text-2">{{ this.$route.query.lastsim }}</h3>
		<h3 class="body-text-2">{{ this.$route.query.facility }}</h3>
	</div>
</template>

<script>
import Accessibility from '@/mixins/Accessibility';
import UserData from '@/mixins/UserData';
export default {
	mixins: [Accessibility, UserData],
	mounted() {
		this.$store.commit('setLoading', false);
		setTimeout(() => {
			this.announceError(this.$t('notFoundInfo'));
		}, 200);
	},
	methods: {
		logout() {
			this.$store.dispatch('logoutSingleSession');
		}
	}
};
</script>

<style scoped>
.message-box {
	height: calc(100% - 50px);
	width: calc(100% - 50px);
	padding-top: calc(50vh - 175px);
	margin: 25px;
	text-align: center;
	color: #fff;
	font-family: 'RobotoRegular';
	font-weight: 300;
	color: #687682;
	background-color: #f6f6f6;
}

.jablue {
	color: #285f74;
}

.bigger {
	font-size: 36px !important;
}

.message-box h1 {
	font-size: 6em;
	line-height: 0.5em;
	margin-bottom: 0.4em;
}

.message-box h2 {
	margin: 0;
	margin-bottom: 50px;
	font-weight: 800;
	font-size: 18px;
}

.buttons-con {
	margin-bottom: 50px;
}

.buttons-con .action-link-wrap {
	margin-top: 2em;
}

.buttons-con .action-link-wrap a {
	background-color: #285f74;
	padding: 8px 25px;
	font-size: 14px;
	transition: all 0.3s linear;
	cursor: pointer;
	text-decoration: none;
	margin-right: 10px;
	border-width: 1px;
	border-color: #285f74;
	color: #fff;
	padding-right: 1.25rem;
	padding-top: 0.75rem;
	padding-bottom: 0.75rem;
	text-transform: uppercase;
	transition: all 0.15s ease-in-out;
	border-radius: 4px;
	box-shadow: 2px 2px 5px #888;
	text-decoration: none;
}

.buttons-con .action-link-wrap a:hover {
	border-color: #285f74;
	background-color: #285f74;
	opacity: 0.9;
}
</style>
